import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { RootStore, UpcomingBookingsStore } from 'AppClient/stores';
import TripDetails from 'AppClient/components/TripDetails';
import NoBookingInfo from 'AppClient/components/NoBookingInfo';
import { isEmpty } from 'lodash-es';
import { Collapse } from 'components/antd';
import { Fragment } from 'components';

import styles from './styles.module.scss';

interface Props {
	upcomingBookingsStore?: UpcomingBookingsStore;
}
@inject(({ upcomingBookingsStore }: RootStore) => ({ upcomingBookingsStore }))
@observer
export class UpcomingBookings extends Component<Props> {
	render() {
		const {
			getTotalCount,
			upcomingBookingsData,
			isSuccess,
		} = this.props.upcomingBookingsStore!;
		const hasDate = isEmpty(upcomingBookingsData) && isSuccess;
		return (
			<Fragment>
				<Collapse defaultActiveKey={['1']}>
					<Collapse.Panel
						header={`UPCOMING${getTotalCount > 0 ? ': ' + getTotalCount : ''}`}
						key={'1'}
					>
						{hasDate ? (
							<NoBookingInfo message="No upcoming bookings yet" />
						) : (
							<div className={styles.upcomingBookings}>
								{upcomingBookingsData.map((ub, index) => {
									return (
										<TripDetails
											index={index}
											key={ub.bookingId}
											addresses={ub.bookingAddresses}
											tripDate={ub.pickUpDateTime}
											carTypeId={ub.carTypeId}
											numberOfPassengers={ub.numberOfPassengers}
											bookingId={ub.bookingId}
											bookingNumber={ub.bookingNumber}
											servicePartnerName={ub.servicePartnerName}
											priceDetails={{
												currencySymbol: ub.customerCurrencySymbol,
												price: ub.totalPriceInCustomerCurrency,
											}}
											globalTransfer={{
												tripDistanceInMeters: ub.distanceInMeters,
												tripDurationInSeconds: ub.durationInSeconds,
											}}
											isNewTrip={false}
										/>
									);
								})}
							</div>
						)}
					</Collapse.Panel>
				</Collapse>
			</Fragment>
		);
	}
}
